import http from '@/assets/common/http';
// 拉取供应商列表
export function supplierList(data) {
  const params = {
    SERVICE_ID: '10001',
    OTYPE: 1,
    GYS_ID: sessionStorage.getItem('tcId'),
    ...data,
  };
  return http.post(params);
}
//   新增/修改供应商
export function addSupplier(data, e) {
  const params = {
    SERVICE_ID: '10001',
    OTYPE: e,
    // SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// -------------------------禁用供应商
export function stopSupplierFun(data) {
  const params = {
    SERVICE_ID: '10001',
    OTYPE: 7,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// -------------------------启用供应商
export function startSupplierFun(data) {
  const params = {
    SERVICE_ID: '10001',
    OTYPE: 8,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 供应商商品批量下架
export function batchDown(data) {
  const params = {
    SERVICE_ID: '10008',
    OTYPE: 38,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// -------------------------拉取供应商管理详情页面
export function querySupOrderFun(data) {
  const params = {
    SERVICE_ID: '10008',
    OTYPE: 20,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// -------------------------筛选新增产品
export function queryNewFun(data) {
  const params = {
    SERVICE_ID: '10008',
    OTYPE: 28,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    PRICE_MODE: 1,
    ...data,
  };
  return http.post(params);
}
// -------------------------增加新增产品
export function addNewFun(data) {
  const params = {
    SERVICE_ID: '10008',
    OTYPE: 2,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// -------------------------删除新增产品
export function removeNewFun(data) {
  const params = {
    SERVICE_ID: '10008',
    OTYPE: 8,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// -------------------------匹配产品页面
export function matchNewFun() {
  const params = {
    SERVICE_ID: '10008',
    OTYPE: 6,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
  };
  return http.post(params);
}
// -------------------------匹配一级大类
export function oneClassFun() {
  const params = {
    SERVICE_ID: '10008',
    OTYPE: 14,
  };
  return http.post(params);
}
export function addClassFun(data) {
  const params = {
    SERVICE_ID: '10008',
    OTYPE: 15,
    GYS_ID: sessionStorage.getItem('tcId'),
    ...data,
  };
  return http.post(params);
}
// ----------------------------二级
export function twoClassFun() {
  const params = {
    SERVICE_ID: '10008',
    OTYPE: 17,
  };
  return http.post(params);
}
export function addTwoClassFun(data) {
  const params = {
    SERVICE_ID: '10008',
    OTYPE: 16,
    GYS_ID: sessionStorage.getItem('tcId'),
    ...data,
  };
  return http.post(params);
}
// -------------------------筛选产品
export function searchFun(data) {
  const params = {
    SERVICE_ID: '10008',
    OTYPE: 9,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// -------------------------匹配产品功能
export function matchNewOrderFun(data) {
  const params = {
    SERVICE_ID: '10008',
    OTYPE: 7,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 解除供应关系
export function deleteSupplier(data) {
  const params = {
    SERVICE_ID: '10001',
    OTYPE: 2,
    GYS_ID: sessionStorage.getItem('tcId'),
    ...data,
  };
  return http.post(params);
}
// ----------------------------------------新增分组功能
export function addGroupFun(data) {
  const params = {
    SERVICE_ID: '10024',
    OTYPE: 1,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ----------------------------------删除分组功能
export function deleteGroupFun(data) {
  const params = {
    SERVICE_ID: '10024',
    OTYPE: 2,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ---------------------------------------修改分组功能
export function updateGroupFun(data) {
  const params = {
    SERVICE_ID: '10024',
    OTYPE: 3,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ---------------------------------------查询分组功能
export function queryGroupFun() {
  const params = {
    SERVICE_ID: '10024',
    OTYPE: 4,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    // ...data
  };
  return http.post(params);
}
// ---------------------------------------档口分组列表管理接口说明
// ---------------------------------------查询某个类别下的档口分组功能（查询）
export function queryGroupDetailFun(data) {
  const params = {
    SERVICE_ID: '10025',
    OTYPE: 3,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ---------------------------------------删除
export function deteleGroupFun(data) {
  const params = {
    SERVICE_ID: '10025',
    OTYPE: 2,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ---------------------------------------匹配档口按钮（显示未分组的档口）
export function matchDKFun(data) {
  const params = {
    SERVICE_ID: '10025',
    OTYPE: 4,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ---------------------------------------新增档口分组功能（匹配操作）
export function matchDKGroupFun(data) {
  const params = {
    SERVICE_ID: '10025',
    OTYPE: 1,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ---------------------------------供应商资质管理
export function supplierContractFun() {
  const params = {
    SERVICE_ID: '10002',
    OTYPE: 6,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    // ...data
  };
  return http.post(params);
}
// -------------------------------------添加供应商管理资质
export function addSupplierContractFun(data) {
  const params = {
    SERVICE_ID: '10002',
    OTYPE: 1,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// -------------------------------------删除供应商管理资质
export function deleteSupplierContractFun(data) {
  const params = {
    SERVICE_ID: '10002',
    OTYPE: 5,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// -------------------------------------查询供应商管理资质
export function queryContractFun(data) {
  const params = {
    SERVICE_ID: '10002',
    OTYPE: 7,
    // SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// -------------------------------------单位管理
export function unitManageFun() {
  const params = {
    SERVICE_ID: '10020',
    OTYPE: 2,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
  };
  return http.post(params);
}
// -------------------------------------修改单位
export function unitUpdateFun(data) {
  const params = {
    SERVICE_ID: '10020',
    OTYPE: 1,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 上架产品
export function putAway(data) {
  const params = {
    SERVICE_ID: '10008',
    OTYPE: 23,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    SUPPLIER_ID: Number(sessionStorage.getItem('supplierId')),
    ...data,
  };
  return http.post(params);
}
// 新增线路
export function submitAdd(data) {
  const params = {
    SERVICE_ID: '10043',
    OTYPE: 1,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 拉取所有线路
export function getLineSetList() {
  const params = {
    SERVICE_ID: '10043',
    OTYPE: 2,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
  };
  return http.post(params);
}
// 获取匹配的项目点信息
export function getLineSetDetail(data) {
  const params = {
    SERVICE_ID: '10043',
    OTYPE: 3,
    ...data,
  };
  return http.post(params);
}
// 获取未匹配的项目点
export function getProjectList() {
  const params = {
    SERVICE_ID: '10043',
    OTYPE: 6,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
  };
  return http.post(params);
}
// 新增匹配关系
export function submitMatch(data) {
  const params = {
    SERVICE_ID: '10043',
    OTYPE: 5,
    ...data,
  };
  return http.post(params);
}
// 解除匹配关系
export function removeLine(data) {
  const params = {
    SERVICE_ID: '10043',
    OTYPE: 4,
    ...data,
  };
  return http.post(params);
}
// 导入供应商
export function exportSupplierFun(data) {
  const params = {
    SERVICE_ID: '10001',
    OTYPE: 11,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 新增部门
export function submitDepartment(data) {
  const params = {
    SERVICE_ID: '10048',
    OTYPE: 1,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 修改部门
export function editDepartment(data) {
  const params = {
    SERVICE_ID: '10048',
    OTYPE: 2,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 禁用部门
export function stopDepartment(data) {
  const params = {
    SERVICE_ID: '10048',
    OTYPE: 3,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 解除禁用
export function openDepartment(data) {
  const params = {
    SERVICE_ID: '10048',
    OTYPE: 4,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 拉取部门
export function queryDepartment(data) {
  const params = {
    SERVICE_ID: '10048',
    OTYPE: 5,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 拉取人员
export function queryPeople(data) {
  const params = {
    SERVICE_ID: '10047',
    OTYPE: 5,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 设置策略
export function setStrategyFun(data) {
  const params = {
    SERVICE_ID: '10020',
    OTYPE: 3,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 设置加点
export function getAddPointFun(data) {
  const params = {
    SERVICE_ID: '10049',
    OTYPE: 8,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 设置加点
export function addPointFun(data) {
  const params = {
    SERVICE_ID: '10049',
    OTYPE: 9,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 修改加点
export function editPointFun(data) {
  const params = {
    SERVICE_ID: '10049',
    OTYPE: 10,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 删除加点
export function deletePointFun(data) {
  const params = {
    SERVICE_ID: '10049',
    OTYPE: 11,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 拉取报价分组
export function getPriceGroupFun(data) {
  const params = {
    SERVICE_ID: '10059',
    OTYPE: 2,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 拉取客户分组
export function getClientGroupFun(data) {
  const params = {
    SERVICE_ID: '10059',
    OTYPE: 11,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 新增报价分组
export function addPriceGroupFun(data) {
  const params = {
    SERVICE_ID: '10059',
    OTYPE: 1,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 新增客户分组
export function addClientGroupFun(data) {
  const params = {
    SERVICE_ID: '10059',
    OTYPE: 10,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 删除分组
export function deleteClientGroupFun(data) {
  const params = {
    SERVICE_ID: '10059',
    OTYPE: 18,
    ...data,
  };
  return http.post(params);
}
// 修改分组名称
export function editClientGroupFun(data) {
  const params = {
    SERVICE_ID: '10059',
    OTYPE: 17,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    GROUP_ID: Number(sessionStorage.getItem('GROUP_ID')),
    ...data,
  };
  return http.post(params);
}
// 筛选分组
export function filterGroupFun(data) {
  const params = {
    SERVICE_ID: '10059',
    OTYPE: 16,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
  };
  return http.post(params);
}
// 拉取某个分组匹配的客户名称
export function getClientGroupCusFun(data) {
  const params = {
    SERVICE_ID: '10059',
    OTYPE: 12,
    GROUP_ID: Number(sessionStorage.getItem('GROUP_ID')),
    ...data,
  };
  return http.post(params);
}
// 解除一个分组匹配
export function deleteClientMatchCusFun(data) {
  const params = {
    SERVICE_ID: '10059',
    OTYPE: 13,
    GROUP_ID: Number(sessionStorage.getItem('GROUP_ID')),
    ...data,
  };
  return http.post(params);
}
// 拉取所有未匹配分组的客户
export function getClientNotMatchCusFun(data) {
  const params = {
    SERVICE_ID: '10059',
    OTYPE: 15,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 增加一个分组匹配
export function ClientmatchCusFun(data) {
  const params = {
    SERVICE_ID: '10059',
    OTYPE: 14,
    GROUP_ID: Number(sessionStorage.getItem('GROUP_ID')),
    ...data,
  };
  return http.post(params);
}
// 拉取已匹配的客户
export function getPriceGroupCusFun(data) {
  const params = {
    SERVICE_ID: '10059',
    OTYPE: 3,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 匹配一个客户
export function matchCusFun(data) {
  const params = {
    SERVICE_ID: '10059',
    OTYPE: 5,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 拉取未匹配的客户
export function getNotMatchCusFun(data) {
  const params = {
    SERVICE_ID: '10059',
    OTYPE: 6,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 解除匹配
export function deleteMatchCusFun(data) {
  const params = {
    SERVICE_ID: '10059',
    OTYPE: 4,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 修改分组名称
export function editPriceGroupFun(data) {
  const params = {
    SERVICE_ID: '10059',
    OTYPE: 8,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 解除匹配
export function deletePriceGroupFun(data) {
  const params = {
    SERVICE_ID: '10059',
    OTYPE: 9,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 设置是否合并订单
export function setAddOrderFun(data) {
  const params = {
    SERVICE_ID: '10020',
    OTYPE: 4,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 设置库存分类
export function setWarekindFun(data) {
  const params = {
    SERVICE_ID: '10020',
    OTYPE: 5,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 采购订单是否生成新订单
export function setShopOrderFun(data) {
  const params = {
    SERVICE_ID: '10020',
    OTYPE: 6,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 设置系统配置长短名称
export function setProductName(data) {
  const params = {
    SERVICE_ID: '10020',
    OTYPE: 7,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 设置价格类型
export function setMemoryPrices(data) {
  const params = {
    SERVICE_ID: '10020',
    OTYPE: 8,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 设置可入库产品
export function setStorage(data) {
  const params = {
    SERVICE_ID: '10020',
    OTYPE: 10,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 可报价时间配置
export function setOfferTime(data) {
  const params = {
    SERVICE_ID: '10020',
    OTYPE: 12,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 获取报价时间
export function querytOfferTime(data) {
  const params = {
    SERVICE_ID: '10020',
    OTYPE: 11,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 批量下架产品
export function upSupplierProduct(data) {
  const params = {
    SERVICE_ID: '10041',
    OTYPE: 30,
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 导出供应商
export function exportSupplier(data) {
  const params = {
    SERVICE_ID: '10041',
    OTYPE: 31,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 快捷销售定价拉取数据
export function querySalePricing(data) {
  const params = {
    SERVICE_ID: '10072',
    OTYPE: 23,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 更新供应商设置（导出合并PDF未填送货数量是否展示为订购数量等）
export function updateSupplierSetting(data) {
  const params = {
    SERVICE_ID: '10017',
    OTYPE: 60,
    SUPPLIER_ID: sessionStorage.getItem('tcId'),
    ...data,
  };
  return http.post(params);
}
// 获取供应商配置
export function getSupplierConfig() {
  const params = {
    SERVICE_ID: '10017',
    OTYPE: 6,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
  };
  return http.post(params);
}
// 修改供应商关系层单位模式
export function updateUnitMode(data) {
  const params = {
    SERVICE_ID: '15072',
    OTYPE: 5,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}



// WEBPACK FOOTER //
// ./src/assets/api/systemSetting.js